import request from '@/router/axios';

export const getList = (current, size, params) => {
    return request({
        url: '/api/v2/blade-loanCarManagePosition/loanCarManagePosition/list',
        method: 'get',
        params: {
            ...params,
            current,
            size
        }
    })
}

export const carGetList = (current, size, params) => {
  return request({
      url: '/api/v2/blade-loanCarManagePosition/loanCarManagePosition/allList',
      method: 'get',
      params: {
          ...params,
          current,
          size
      }
  })
}

export const remove = (ids) => {
    return request({
        url: '/api/v2/blade-loanCarManagePosition/loanCarManagePosition/remove',
        method: 'post',
        params: {
            ids,
        }
    })
}

export const add = (row) => {
    return request({
        url: '/api/v2/blade-loanCarManagePosition/loanCarManagePosition/save',
        method: 'post',
        data: row
    })
}

export const update = (row) => {
    return request({
        url: '/api/v2/blade-loanCarManagePosition/loanCarManagePosition/update',
        method: 'post',
        data: row
    })
}


export const getCompanyList = () => {
    return request({
        url: '/api/blade-system/dept/queryingAllNodes',
        method: 'get'
    })
}
